import axios from 'axios';
import endpoints from 'services/endpoints';
import { Statement } from 'types/types';

export const getStatementsForBranch = (branchId: number): Promise<Statement[]> =>
  axios.get(endpoints.statements(branchId)).then((response) => response.data);
